import { SearchOutlined } from "@ant-design/icons";
import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTableSchema } from "../../store/actions/CommonActions";
import { setContentLoading, setExtraContent } from "../../store/reducers/CommonReducer";
import { setIsUserProfileTab, setProfileFilteredList, setProfileTableSchema } from "../../store/reducers/UUMReducer";
import { setProgKeysProfFilteredList, setProgKeysProfTableSchema } from "../../store/reducers/ProgKeysReducer";
import { PURPLE } from "../../styles/styleUtils";
import { formatDictString, getTranslated, tableListFilter } from "../../utils/CommonUtils";
import { UUM_URL } from "../../utils/Config";
import { PROFILE_TOGGLE_ITEMS, UPDATE, USERS_PROFILE, PROGKEYS_PROFILE } from "../../utils/Constants";
import CustomTable from "../common/CustomTable";
import TextField from "../common/TextField";
import ToggleButton from "../common/ToggleButton";
import UMCButton from "../common/UMCButton";
import { useWindowSize } from "../customHooks/useWindowSize";
import CreateKeyProfileView from "./CreateKeyProfileView";
import UserProfileSummaryView from "./UserProfileSummaryView";
import CreateUserProfDetailView from "./CreateUserProfDetailView";
import { deleteUserProfile, getProfileList } from "../../store/actions/UUMActions";
import { getProgKeysProfList } from "../../store/actions/ProgKeysAction"
import confirmModal from "../common/confirmModal";


const viewModes = {
    LIST: "list",
    SUMMARY: "summary",
    DETAIL: "detail"
}

const Profiles = () => {

    const [viewMode, setViewMode] = useState(viewModes.LIST)
    const [selectedProfile, setSelectedProfile] = useState()
    const [seletedRows, setSelectedRows] = useState([])
    const [isReadOnly, setIsReadOnly] = useState(false)

    const profileTableSchema = useSelector(state => state.uum.profileTableSchema)
    const profileFilteredList = useSelector(state => state.uum.profileFilteredList)
    const profileTableList = useSelector(state => state.uum.profileTableList)
    const progKeysProfTableSchema = useSelector(state => state.progkeys.progKeysProfTableSchema)
    const progKeysProfTableList = useSelector(state => state.progkeys.progKeysProfTableList)
    const progKeysProfFilteredList = useSelector(state => state.progkeys.progKeysProfFilteredList)
    const isUserProfileTab = useSelector((state) => state.uum.isUserProfileTab)
    const dict = useSelector(state => state.common.dict)

    const dispatch = useDispatch()

    const [width, height] = useWindowSize()

    useEffect(() => {
        if ((profileTableSchema?.length && profileTableList) || (progKeysProfTableSchema?.length && progKeysProfTableList))
            dispatch(setContentLoading(false))
    }, [profileTableSchema, profileTableList, progKeysProfTableSchema, progKeysProfTableList])

    useEffect(() => {
        let extraContent = []
        switch (viewMode) {
            case viewModes.LIST:
                extraContent = ["refresh", "help"];
                break;
            case viewModes.SUMMARY:
                extraContent = ["help"];
                break;
            case viewModes.DETAIL:
                extraContent = ["help"];
                break;
            default:
                break
        }

        dispatch(setExtraContent(extraContent))
    }, [viewMode])

    useEffect(() => {
        getTableData()
    }, [isUserProfileTab, dict])

    const getTableData = () => {
        dispatch(setContentLoading(true))

        if (isUserProfileTab) {
            // Get Profiles Table schema
            !(profileTableSchema?.length) && dispatch(getTableSchema({ url: `${UUM_URL}/schema/list/easyuserprofile`, action: setProfileTableSchema }))

            // Get Profiles Table data
            dispatch(getProfileList())
        } else {
            // Get Keys-Profiles Table schema
            !(progKeysProfTableSchema?.length) && dispatch(getTableSchema({ url: `${UUM_URL}/schema/list/keysprofile`, action: setProgKeysProfTableSchema }))

            // Get Keys-Profiles Table data
            dispatch(getProgKeysProfList())
        }
    }

    const handleTableSearch = (searchVal) => {
        const filteredArr = tableListFilter(profileTableList, searchVal)

        dispatch(setProfileFilteredList(filteredArr))
    }

    const setListViewMode = (value) => {
        value && getTableData()
        setViewMode(value ? viewModes.LIST : viewModes.SUMMARY)
    }

    const handleRowSelect = (rowData) => {
        setViewMode(viewModes.DETAIL)
        setSelectedProfile(rowData.key)
        setIsReadOnly(rowData.modifiable ? false : true)
    }

    const handleRowDelete = (key) => {
        dispatch(setContentLoading(true))
        dispatch(deleteUserProfile(key, (status, resp) => {

            if (status)
                dispatch(getTableData())
            // else {
            //     dispatch(setContentLoading(false))
            //     confirmModal({
            //         title: "Profile deletion failed",
            //         content: resp?.errorMessage,
            //         type: "error",
            //         okText: "OK"
            //     })
            // }
        }))
    }

    const getExportLabel = () => {
        if (!seletedRows?.length) return getTranslated(dict, "LABEL_EXPORT")

        if (isUserProfileTab) {
            return profileFilteredList.filter(item => item.bulk === true).length === seletedRows.length ? getTranslated(dict, `LABEL_EXPORT_ALL`) :  formatDictString(dict, "LABEL_EXPORT_N_ITEMS", { n: seletedRows.length })

        } else {
            return progKeysProfFilteredList?.length === seletedRows.length ? getTranslated(dict, `LABEL_EXPORT_ALL`) : formatDictString(dict, "LABEL_EXPORT_N_ITEMS", { n: seletedRows.length })
        }
    }

    const showDeleteConfirm = (key) => {
        confirmModal({
            title: "MSG_SURE_DEL_PROF",
            content: "MSG_CONFIRM",
            error: true,
            onOk() {
                handleRowDelete(key)
            }
        })
    }

    const getProfilesHeader = () => {

        return <div className="inner-tab-hd-container">
            <TextField
                handleChange={handleTableSearch}
                className="user-search"
                prefix={<SearchOutlined style={{ fontSize: "10px", color: PURPLE }} />}
                placeholder={getTranslated(dict, "LABEL_SEARCH")}
            />

            <UMCButton label={getTranslated(dict, "LABEL_CREATE")} onClick={() => setListViewMode(false)} type="primary" className="cont-header-btn" />
            <UMCButton label={getTranslated(dict, "LABEL_IMPORT")} disabled type="primary" className="cont-header-btn" />
            <UMCButton label={getExportLabel()} type="primary" className="cont-header-btn" disabled={true || !seletedRows?.length} />

            <ToggleButton
                options={PROFILE_TOGGLE_ITEMS}
                className="cont-header-btn last-option"
                value={isUserProfileTab}
                handleChange={(value) => dispatch(setIsUserProfileTab(value))}
            />
        </div>
    }

    const getTable = () => {

        return <CustomTable
            schema={isUserProfileTab ? profileTableSchema : progKeysProfTableSchema}
            filteredData={isUserProfileTab ? profileFilteredList : progKeysProfFilteredList}
            tableData={isUserProfileTab ? profileTableList : progKeysProfTableList}
            updateTableAction={isUserProfileTab ? setProfileFilteredList : setProgKeysProfFilteredList}
            handleRowSelect={handleRowSelect}
            handleRowDelete={(key) => showDeleteConfirm(key)}
            height={height <= 585 ? "22em" : "55vh"}
            bulk={true}
            handleBulkSelection={(rows) => setSelectedRows(rows)}
            tabKey={isUserProfileTab ? USERS_PROFILE : PROGKEYS_PROFILE}
        />
    }


    return <div id="inner-tab-content">
        {viewMode === viewModes.LIST ? <>
            <div style={{ marginBottom: "14px" }}>
                {getProfilesHeader()}
            </div>
            {getTable()}
        </> : isUserProfileTab ? viewMode === viewModes.SUMMARY ?
            <UserProfileSummaryView
                setListViewMode={setListViewMode}
                heading_1={getTranslated(dict, "MSG_CHOOSE_PROF_TEMPLATE")}
                heading_2={getTranslated(dict, "MSG_SEL_PERSONALIZED_PROF")}
                type="profile"
            /> :
            <CreateUserProfDetailView
                selectedProfile={selectedProfile}
                changeCreateMode={setListViewMode}
                backToListView={setListViewMode}
                mode={UPDATE}
                isReadOnly={isReadOnly}
            /> :
            <CreateKeyProfileView
                setListViewMode={setListViewMode}
                mode={UPDATE}
            />}
    </div>
}

export default memo(Profiles)